import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const LaunchIcon = (props: SVGProps) => {
  return <SpriteIcon spriteId="link-external" {...props} />;
};

export { LaunchIcon };
